import { Building2Icon, LockIcon, SendIcon } from "lucide-react";

import { Row, Text } from "@/components";

import { cn } from "@/lib/utils";

export type CommunicationsTab = "company" | "external" | "internal";

export const CommunicationsScopeBanner = ({
  candidateName,
  className,
  communicationsTab,
  companyName,
}: {
  candidateName: string;
  className?: string;
  communicationsTab: CommunicationsTab;
  companyName?: string;
}) => {
  /* Helpers */
  const displayName = candidateName.trim() || "the candidate";
  const displayCompanyName = (companyName ?? "").trim() || "the company";

  const bannerMeta = (() => {
    if (communicationsTab === "external") {
      return {
        Icon: SendIcon,
        message: `External · sent directly to ${displayName}`,
        textClassName: "text-primary-700",
      };
    }

    if (communicationsTab === "company") {
      return {
        Icon: Building2Icon,
        message: `Communicating with ${displayCompanyName}`,
        textClassName: "text-slate-500",
      };
    }

    return {
      Icon: LockIcon,
      message: `Internal · not visible to ${displayName}`,
      textClassName: "text-slate-500",
    };
  })();
  const BannerIcon = bannerMeta.Icon;

  /* Render */
  const render = () => {
    return (
      <Row
        className={cn(
          "shrink-0 items-center gap-2",
          bannerMeta.textClassName,
          className,
        )}
      >
        <BannerIcon className="h-3.5 w-3.5 shrink-0" />
        <Text
          className={cn(
            "min-w-0 truncate text-xs font-medium",
            bannerMeta.textClassName,
          )}
          variant="secondary"
        >
          {bannerMeta.message}
        </Text>
      </Row>
    );
  };

  return render();
};
